let appId = 'nkC12hLy';
if (window.location.hostname !== 'app.getporter.io') {
  appId = 't9Ikawfg';
}

const TALK_APP_ID = appId;
export default TALK_APP_ID;
